// toc-nav.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TocNavService {
  private fromTocClick = false;

  private _linkActivated = new Subject<void>();
  /** Emits whenever the user clicks a TOC link */
  readonly linkActivated$ = this._linkActivated.asObservable();

  private readonly openedSubject = new Subject<void>();
  readonly opened$ = this.openedSubject.asObservable();

  markClick(): void {
    this.fromTocClick = true;
    this._linkActivated.next();
  }

  consumeClickFlag(): boolean {
    const v = this.fromTocClick;
    this.fromTocClick = false;
    return v;
  }

  notifyOpened(): void {
    this.openedSubject.next();
  }
}
